module.exports = __webpack_public_path__ + "static/media/firstmedia_paynow.dbb245eb.png";